import { IAnalyticsScorecard } from '@/types/analytics';
import { Get } from '../helpers';

const GetEventTotalInvitedCount = ({
  projectUuid,
  signal,
}: {
  projectUuid: string;
  signal?: AbortSignal;
}): Promise<IAnalyticsScorecard | null> => {
  return Get({
    path: `/v3/admin/metrics/events/${projectUuid}/total-invites`,
    signal,
    isMetrics: true,
  });
};

export default GetEventTotalInvitedCount;
